var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgResursiVideo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 325",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-6,.cls-8{fill:none;stroke-width:1.5px;}.cls-1{stroke:#231f20;stroke-linejoin:round;}.cls-1,.cls-6{stroke-linecap:round;}.cls-2{fill:#159497;}.cls-3{fill:#aa6276;}.cls-4{fill:#fa7268;}.cls-5{fill:#6e5dd8;}.cls-6{stroke:#000;}.cls-6,.cls-8{stroke-miterlimit:10;}.cls-7{fill:#fff;}.cls-8{stroke:#fa7268;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "600x325") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 160.2,
    y: 36.76,
    width: 383.78,
    height: 223.53,
    rx: 24.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 163.61,
    y1: 77.86,
    x2: 543.98,
    y2: 77.86
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 188.37,
    cy: 57.95,
    r: 9.57
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 220.04,
    cy: 57.95,
    r: 9.57
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 251.7,
    cy: 57.95,
    r: 9.57
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 543.98,
    cy: 130.53,
    r: 8.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 418.7,
    y: 287.73,
    width: 11,
    height: 11
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "36.03 116.02 44.97 100.53 27.09 100.53 36.03 116.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M195.24,118.17a10.47,10.47,0,0,0-9.22-15.8,59.58,59.58,0,1,0-1.65,20.85A10.52,10.52,0,0,0,195.24,118.17Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167.87,
    cy: 100.7,
    r: 4.03
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M171.64,143.22a9.36,9.36,0,0,1-11.44-6.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M180.74,83A59.71,59.71,0,0,0,75,78.05,60.25,60.25,0,0,0,68.9,92.54h0l0,.08c-5.71,17.28-5.71,87.61-5.71,87.61l71.15-5.32L122.78,95.77C144.9,92.93,161.5,90.19,180.74,83Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 123.26,
    cy: 120.05,
    r: 10.16
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 70.77,
    cy: 54.59,
    r: 23.26
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M34.51,302.87,50,236.78a73.22,73.22,0,0,1,71.29-56.55h0a73.21,73.21,0,0,1,70.08,52l21.35,70.62Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 352.09,
    cy: 159.17,
    r: 44.53
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M372.94,157.51l-31.76-18.33a1.91,1.91,0,0,0-2.86,1.65V177.5a1.91,1.91,0,0,0,2.86,1.65l31.76-18.33A1.91,1.91,0,0,0,372.94,157.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M361.38,299.12a125.91,125.91,0,0,1,31.47-58.43c6.89-7.21,15-13.78,24.63-16.31s21.09-.18,27.13,7.76c5.08,6.67,5.48,15.62,6.81,23.89s4.65,17.41,12.41,20.55c8,3.25,17.29-1.58,22.78-8.26s8.51-15,13.22-22.29c14.09-21.74,44.49-31.14,68.39-21.16"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResursiVideo);
export default __webpack_public_path__ + "static/media/Resursi-video.9bfa29bbd32a804e91e9ba948caf1cb0.svg";
export { ForwardRef as ReactComponent };